// extracted by mini-css-extract-plugin
export default {"container":"BillingPayments_container__XkszU","title":"BillingPayments_title__KBGSN","paymentsList":"BillingPayments_paymentsList__9QooV"};